<template class="results-list">
  <ul
    :id="list + '-results'"
    class="py-1 px-0 list-unstyled result-list-wrap"
    :class="{ 'mobile-result-list': mobile }"
  >
    <b-modal
      id="mobile-more-modal"
      v-model="showMobileMore"
      no-fade
      hide-footer
      modal-class="p-2"
      header-class="text-center bg-white m-auto"
      :title="'הרחבה של ' + modalTitle"
      @show="modalShow"
      @hidden="modalClosed"
    >
      <div v-html="listContent" @click="copyMobileResult"></div>
    </b-modal>
    <span v-if="mobile">
      <li
        @click="copyMobileResult"
        v-for="(n, index) in resultsToShow"
        :key="index"
        :ref="'resultItem' + list"
      >
        <span v-if="defaultResults[index]">
          <i
            class="fas fa-bars"
            @click="openList(index, defaultResults[index].forms[0])"
            v-if="
              defaultResults[index].forms &&
              defaultResults[index].forms.length > 1
            "
          ></i>
          <p
            class="d-inline-block m-0 p-0 f-narkis"
            :style="fitText(list, index)"
          >
            <!--:style="fitText(list,index)"-->
            {{
              defaultResults[index].forms !== undefined
                ? defaultResults[index].forms[0]
                : defaultResults[index]
            }}
          </p>
          <ul
            :id="list + 'list-' + index"
            class="list-unstyled dropdown border-top border-bottom bg-white py-2"
            v-if="
              defaultResults[index].forms &&
              defaultResults[index].forms.length > 1
            "
            style="display: none"
          >
            <li
              class="pb-1 px-0 sub-results"
              v-for="(formItem, formIndex) in defaultResults[index].forms"
              :key="formIndex"
              :class="{
                'selected-inner': selectedWords.indexOf(formItem) > -1,
              }"
            >
              <p class="d-inline px-2">
                {{ formItem }}
              </p>
            </li>
          </ul>
        </span>
      </li>
      <span ref="trigger" />
      <div v-if="resultsToShow < defaultResults.length">
        <b-button
          variant="link"
          class="text-primary m-auto text-center d-block"
          @click="showMoreResults"
        >
          טוען תוצאות נוספות …
        </b-button>
      </div>
      <div
        class="text-center"
        v-if="
          resultsToShow >= defaultResults.length && defaultResults.length > 14
        "
      >
        אין תוצאות נוספות
      </div>
    </span>
    <span v-else>
      <li
        class="f-narkis sub-result"
        v-for="(item, index) in defaultResults"
        :key="index"
        :class="{
          'bg-background': index % 2 == 0,
          selected:
            selectedWords.indexOf(
              item.forms !== undefined ? item.forms[0] : item
            ) > -1,
          'dropdown-items': item.forms !== undefined && item.forms.length > 1,
        }"
      >
        <i class="fas fa-bars d-none" @click="openList(index)"></i>
        <i
          class="far fa-star d-none"
          @click="addToList(item.forms[0])"
          v-if="selectedWords.indexOf(item.forms[0]) === -1"
        ></i>
        <i
          class="fas fa-star d-none"
          @click="removeFromList(item.forms[0])"
          v-else
        ></i>
        <p class="d-inline-block m-0" @click="addToListMobile(item.forms[0])">
          {{ item.forms !== undefined ? item.forms[0] : item }}
        </p>
        <span class="d-none mx-2" @click="openList(index)">
          <small
            class="text-muted bg-secondary"
            v-if="item.forms !== undefined && item.forms.length > 1"
            >{{ item.lex }}, {{ item.forms.length
            }}{{ item.has_more_forms ? "+" : "" }}
            {{ hebrew ? "תוצאות" : "results" }}</small
          >
        </span>
        <span
          class="mx-2 f-arimo lex"
          v-if="
            item.forms !== undefined &&
            item.forms.length == 1 &&
            list === 'general'
          "
        >
          <small class="text-muted bg-secondary px-2">{{ item.lex }}</small>
        </span>
        <ul
          :id="list + 'list-' + index"
          class="list-unstyled dropdown border-top border-bottom bg-white py-2"
          v-if="item.forms !== undefined && item.forms.length > 1"
          style="display: none"
        >
          <li
            class="pb-1 px-0"
            v-for="(formItem, formIndex) in item.forms"
            :key="formIndex"
            :class="{ 'selected-inner': selectedWords.indexOf(formItem) > -1 }"
          >
            <i
              class="fas fa-square border-right border-bottom text-white position-relative"
              aria-hidden="true"
            ></i>
            <i
              class="far fa-star d-none"
              @click="addToList(formItem)"
              v-if="selectedWords.indexOf(formItem) === -1"
            ></i>
            <i
              class="fas fa-star d-none"
              @click="removeFromList(formItem)"
              v-else
            ></i>
            <p class="d-inline px-2">
              {{ formItem }}
            </p>
          </li>
        </ul>
      </li>
    </span>
  </ul>
</template>
<script>
import listMethods from "@/mixins/ListMethods.js"
import { RunStates } from "@/store/runStates"
export default {
  name: "ResultsList",
  mixins: [listMethods],
  props: ["list", "activeTab"],
  data() {
    return {
      listContent: "",
      modalTitle: "",
      observer: null,
      wordList: [],
    }
  },
  mounted() {
    this.resultsPerTab(0)
    this.$nextTick(function () {
      if (this.rhymeResults.length > 0 && !this.overviewMode) {
        this.rhymeResults.map((item) => {
          if (item.forms && item.forms.length >= 1) {
            item.forms.forEach((element) => this.wordList.push(element))
          } else if (!item.forms || item.forms.length === 0)
            this.wordList.push(item.lex)
        })
        this.$emit("word-list", this.wordList)
      }
    })
  },
  methods: {
    fitText(list, index) {
      this.$nextTick(function () {
        if (this.$refs["resultItem" + list]) {
          let listItem = this.$refs["resultItem" + list][index]
          if (listItem.clientWidth > 0) {
            let innerP = listItem.getElementsByTagName("P")[0]
            let innerI = listItem.getElementsByTagName("I")[0]
            let innerWidth = innerP.clientWidth
            if (innerI) {
              innerWidth += 22
            }
            if (innerWidth + 40 > listItem.clientWidth) {
              innerP.style.fontSize = 22 + "px"
              if (innerI) {
                innerI.style.fontSize = 15 + "px"
                innerI.style.marginTop = 3 + "px"
              }
            }
          }
        }
      })
    },
    resultsPerTab(tabIndex) {
      switch (tabIndex) {
        case 0:
          this.currentTabLength = this.charuzitCommonResponse.length
          break
        case 2:
          this.currentTabLength = this.allRhymesResponse.length
          break
        case 3:
          this.currentTabLength = this.nsResponse.length
          break
        case 4:
          this.currentTabLength = this.longResponse.length
          break
        case 5:
          this.currentTabLength = this.femResponse.length
          break
      }
      this.setVisibleResults()
    },
    openList(index, txt) {
      var selectedList = document.getElementById(this.list + "list-" + index)
      if (this.mobile) {
        this.modalTitle = txt
        this.listContent = selectedList.innerHTML
        this.savedPos = window.scrollY
        this.showMobileMore = true
      } else {
        if (selectedList) {
          if (selectedList.style.display === "none") {
            selectedList.style.display = "block"
          } else {
            selectedList.style.display = "none"
          }
        }
      }
    },
  },
  computed: {
    complete() {
      return this.$store.state.charuzitApiState === RunStates.COMPLETE
    },
    allRhymesResponse() {
      return this.searchModel == "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.charuzitAssonanceResponse
          : this.consonanceMode
          ? this.$store.state.charuzitConsonanceResponse
          : this.assonanceConsonanceOff
          ? []
          : this.$store.state.charuzitApiResponse
        : this.$store.state.charuzitApiResponse
    },
    allfMore() {
      return this.searchModel == "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.charuzitMoreResultsAS
          : this.consonanceMode
          ? this.$store.state.charuzitMoreResultsCON
          : this.assonanceConsonanceOff
          ? false
          : this.$store.state.charuzitMoreResults
        : this.$store.state.charuzitMoreResults
    },
    charuzitCommonResponse() {
      return this.searchModel == "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.AScommonResults
          : this.consonanceMode
          ? this.$store.state.CONcommonResults
          : this.assonanceConsonanceOff
          ? []
          : this.$store.state.commonResults
        : this.$store.state.commonResults
    },
    commonFMore() {
      return this.searchModel == "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.commonMoreResultsAS
          : this.consonanceMode
          ? this.$store.state.commonMoreResultsCON
          : this.assonanceConsonanceOff
          ? false
          : this.$store.state.commonMoreResults
        : this.$store.state.commonMoreResults
    },
    nsResponse() {
      return this.searchModel == "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.ASnsResults
          : this.consonanceMode
          ? this.$store.state.CONnsResults
          : this.assonanceConsonanceOff
          ? []
          : this.$store.state.nsResults
        : this.$store.state.nsResults
    },
    nsFMore() {
      return this.searchModel == "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.noSuffixMoreResultsAS
          : this.consonanceMode
          ? this.$store.state.noSuffixMoreResultsCON
          : this.assonanceConsonanceOff
          ? false
          : this.$store.state.noSuffixMoreResults
        : this.$store.state.noSuffixMoreResults
    },
    longResponse() {
      return this.searchModel == "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.ASlongResults
          : this.consonanceMode
          ? this.$store.state.CONlongResults
          : this.assonanceConsonanceOff
          ? []
          : this.$store.state.longResults
        : this.$store.state.longResults
    },
    longFMore() {
      return this.searchModel == "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.longMoreResultsAS
          : this.consonanceMode
          ? this.$store.state.longMoreResultsCON
          : this.assonanceConsonanceOff
          ? false
          : this.$store.state.longMoreResults
        : this.$store.state.longMoreResults
    },
    femResponse() {
      return this.searchModel === "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.ASfemResults
          : this.consonanceMode
          ? this.$store.state.CONfemResults
          : this.assonanceConsonanceOff
          ? []
          : this.$store.state.femResults
        : this.$store.state.femResults
    },
    femFMore() {
      return this.searchModel === "xxsonance"
        ? this.assonanceMode
          ? this.$store.state.femMoreResultsAS
          : this.consonanceMode
          ? this.$store.state.femMoreResultsCON
          : this.assonanceConsonanceOff
          ? false
          : this.$store.state.femMoreResults
        : this.$store.state.femMoreResults
    },
    charuzitResponse() {
      return this.list === "common"
        ? this.charuzitCommonResponse
        : this.list === "ns"
        ? this.nsResponse
        : this.list === "long"
        ? this.longResponse
        : this.list === "fem"
        ? this.femResponse
        : this.allRhymesResponse
    },
    charuzitfMore() {
      return this.list === "common"
        ? this.commonFMore
        : this.list === "ns"
        ? this.nsFMore
        : this.list === "long"
        ? this.longFMore
        : this.list === "fem"
        ? this.femFMore
        : this.allfMore
    },
    rhymeResultsSlice() {
      return this.rhymeResults.slice(0, 10)
    },
    rhymeResults() {
      return this.charuzitResponse ? this.charuzitResponse : []
    },
    defaultResults() {
      switch (this.list) {
        case "common":
          this.$emit(
            "commonResults",
            this.charuzitResponse.length,
            this.commonFMore,
            this.rhymeResults
              .slice(0, 10)
              .map((t) => t.forms[0])
              .join(", ")
          )
          break
        case "ns":
          this.$emit("nsResults", this.charuzitResponse.length, this.nsFMore)
          break
        case "long":
          this.$emit(
            "longResults",
            this.charuzitResponse.length,
            this.longFMore
          )
          break
        case "fem":
          this.$emit("femResults", this.charuzitResponse.length, this.femFMore)
          break
        case "general":
          this.$emit(
            "results",
            this.charuzitResponse.length,
            this.charuzitfMore
          )
          break
      }
      return this.overviewMode && !this.mobile
        ? this.rhymeResultsSlice
        : this.rhymeResults
    },
  },
  watch: {
    defaultResults() {
      if (this.complete && this.defaultResults && this.mobile) {
        if (
          this.charuzitCommonResponse &&
          this.charuzitCommonResponse.length > 0
        ) {
          this.resultsPerTab(0)
        } else if (this.BibleResponse && this.BibleResponse.length > 0) {
          //Bible results
        } else if (
          this.allRhymesResponse &&
          this.allRhymesResponse.length > 0
        ) {
          this.resultsPerTab(2)
        } else if (this.nsResponse && this.nsResponse.length > 0) {
          this.resultsPerTab(3)
        } else if (this.longResponse && this.longResponse.length > 0) {
          this.resultsPerTab(4)
        } else if (this.femResponse && this.femResponse.length > 0) {
          this.resultsPerTab(5)
        } else {
          this.$store.commit("SET_NO_RESULTS", true)
        }
      }
    },
    activeTab(val) {
      this.resultsPerTab(val)
    },
  },
}
</script>
<style lang="scss">
body.modal-open {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}
.mobile-result-list {
  overflow: auto;
  min-height: 36vh;
  display: block;
}
#mobile-more-modal {
  .modal-dialog {
    height: 95%;
  }
  .modal-header {
    position: fixed;
    width: 90%;
    top: 16px;
    right: 5%;
    @media screen and (orientation: landscape) {
      width: 97.6%;
      right: 1.2%;
    }
    z-index: 999999;
    h5 {
      padding: 0 25px;
      text-align: center;
      width: 100%;
    }
  }
  .modal-content {
    height: 100%;
  }
  .modal-body {
    padding-top: 45px;
    // height: 90%;
    overflow-y: scroll;
  }
  li {
    list-style-type: none;
    border-radius: 6px;
    background-color: #f6f6f6;
    font-size: 26px;
    &.mobile-bible-item {
      font-size: 20px;
      height: auto;
      line-height: 26px;
    }
    margin-bottom: 8px;
    text-align: center;
    p {
      font-family: Roboto, mft_narkisclassic, sans-serif;
      b {
        color: var(--primary);
      }
    }
  }
  button {
    position: absolute;
    right: 15px;
    font-weight: normal;
    opacity: 1;
    font-size: 30px;
  }
}
.f-arimo {
  font-family: Arimo;
}
</style>
<style scoped lang="scss">
@import "list";
</style>
